module.exports = __webpack_public_path__ + "img/jcb.696d8202.png";